/**
 *
 * @author: Matthew Rawson @ 18/05/2018 11:03
 * @description:
 * @notes:
 */
import React from "react"
import PropTypes from "prop-types"
import {Row, Col} from "react-bootstrap"

import id from "@irati/utils/id"
import {H3} from "@irati/ui/src/Headings"
import {Hr} from "@irati/ui/src/Layout"
import {SectionPosRel} from "@irati/ui/src/Layout/Section"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"

import {ScheduleSettingsForm} from "../../components/Schedule"
import SendExampleSurveyContainer from "../../components/Schedule/Actions/SendExampleSurveyContainer"


const ScheduleSettings = (props) => {
  const idNamespace = id("ScheduleSettings", props)
  const formProps = {...props, id: idNamespace}
  const {schedule} = props

  return (
    <SectionPosRel id={idNamespace}>
      <ScheduleSettingsForm {...formProps} />

      <Hr />

      <Row>
        <Col xs={12} md={6}>
          <H3><FormattedMessage id="insights.schedule.sendExampleSurvey.secondaryButton.label" /></H3>
          <Para>
            <FormattedMessage id="insights.schedule.settings.sendExampleSurvey.text" />
          </Para>
        </Col>
        <Col xs={12} md={6}>
          <SendExampleSurveyContainer schedule={schedule} />
        </Col>
      </Row>
    </SectionPosRel>
  )
}


ScheduleSettings.propTypes = {
  schedule: PropTypes.object
}
ScheduleSettings.defaultProps = {
  schedule: null
}

export default ScheduleSettings
